export const saleOfServicesState = {
  name: 'saleOfServicesState',
  url: '/stats/sale-of-services',
  component: 'saleOfServices',
  resolve: {},
  data: {
    title: 'Реализация услуг',
  },
}
